module.exports = __webpack_public_path__ + "static/media/sidebar-arrow.2a540792.svg";